import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import * as Yup from "yup";
import {RuoliContext} from "../../context/RuoliContext";
import {TranslateContext} from "../../context/TranslateContext";
import {
    aggiornaUtenteApi, aggiungiUtenteApi, getUtenteByIdApi,
} from "./services/UtentiServices";
import {
    aggiungiRelazioneUtenteGruppoApi, getGruppiUtenteApi,
    getGruppiUtenteByIdUsrApi,
    rimuoviUtenteDaGruppoApi
} from "../gruppi-utente/services/GruppiUtentiServices";
import {getRuoliApi} from "../ruoli/services/RuoliServices";
import ModificaUtenteView from "./ModificaUtenteView";

export default function ModificaUtenteController() {
    const {id} = useParams()

    const [loadingData, setLoadingData] = useState(true);
    const [optionsRuoli, setOptionsRuoli] = useState([]);
    const [optionsGruppi, setOptionsGruppi] = useState([]);
    const [gruppiUtente, setGruppiUtente] = useState([]);
    const [gruppoSel, setGruppoSel] = useState();
    const [show, setShow] = useState(false);
    const [showConfirmGruppoDel, setShowConfirmGruppoDel] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [idUsr, setIdUsr] = useState(id);
    const [utente, setUtente] = useState();
    const [showPermessi, setShowPermessi] = useState(false);
    const [idGruppoSel, setIdGruppoSel] = useState();

    const {isRuoloSuperAdmin, isIdRuoloOperatore} = useContext(RuoliContext);
    const {translate} = useContext(TranslateContext);

    const history = useHistory();
    const formikRef = useRef();
    const formikRefGruppi = useRef();

    const statiUtenteAttivo = [{
        id: 1,
        descrizione: translate("Attivo")
    }, {
        id: 0,
        descrizione: translate("Non attivo")
    }];

    async function getRuoli() {
        const response = await getRuoliApi();
        setOptionsRuoli(response.data.data);
    }

    async function getGruppiUtente() {
        const response = await getGruppiUtenteByIdUsrApi(idUsr);
        setGruppiUtente(response.data.data);
    }

    async function getOptionGruppiUtente() {
        const response = await getGruppiUtenteApi();
        setOptionsGruppi(response.data.data);
    }

    async function getUtente() {
        const response = await getUtenteByIdApi(idUsr);
        let val = response.data.data;
        setLoadingData(false);
        setUtente(val);

        if (formikRef.current) {
            formikRef.current.setFieldValue("id_utente", val.id_utente);
            formikRef.current.setFieldValue("nome", val.nome);
            formikRef.current.setFieldValue("cognome", val.cognome);
            formikRef.current.setFieldValue("mail", val.mail);
            formikRef.current.setFieldValue("id_ruolo", val.id_ruolo);
            formikRef.current.setFieldValue("attivo", val.attivo);
        }
    }

    useEffect(() => {
        if (loadingData) {
            if (idUsr && idUsr !== '') {
                getUtente();
                getGruppiUtente();
            }
            getRuoli();
            getOptionGruppiUtente();
        }
    }, [idUsr, id, loadingData]);

    const SignupSchema = Yup.object().shape({
        nome: Yup.string()
            .max(150, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        cognome: Yup.string()
            .max(150, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio')),
        mail: Yup.string()
            .required(translate('Questo campo è obbligatorio'))
            .when('sys', {
                is: '0',
                then: Yup.string().email(translate('Indirizzo E-mail non valido'))
            }),
        id_ruolo: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        attivo: Yup.string()
            .required(translate('Questo campo è obbligatorio'))
    });

    async function rimuoviUtenteDaGruppo() {
        const response = await rimuoviUtenteDaGruppoApi(idUsr, gruppoSel.id_rel_gruppo_utente);
        setGruppiUtente(response.data.data);
    }

    async function aggiornaUtente(values) {
        const response = await aggiornaUtenteApi(idUsr, values);
        if (response.data.result === 0) {
            history.push("/conf-utenti");
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiUtente(values) {
        const response = await aggiungiUtenteApi(values);
        if (response.data.result === 0) {
            setIdUsr(response.data.data.id_utente);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiungiRelazioneUtenteGruppo(values) {
        let relazione = {
            id_gruppo_utente: values.id_gruppo_utente,
            id_utente: idUsr
        };
        const response = await aggiungiRelazioneUtenteGruppoApi(idUsr, relazione);
        if (response.data.result === 0) {
            setGruppiUtente(response.data.data);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    function handleOkConfirmElimina() {
        setShowConfirmGruppoDel(false);
        rimuoviUtenteDaGruppo();
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: () => {
                if (formikRef.current) {
                    formikRef.current.handleSubmit()
                }
            }
        }
    ];

    const initialValuesForm = {
        id_utente: '',
        nome: '',
        cognome: '',
        mail: '',
        id_ruolo: '',
        attivo: '1'
    };

    const initialValuesFormGrupi = {
        id_gruppo_utente: ''
    };

    function onSubmitForm(values) {
        if (idUsr) {
            aggiornaUtente(values);
        } else {
            aggiungiUtente(values);
        }
    }

    function onSubmitFormGruppi(values) {
        if (values.id_gruppo_utente !== '') {
            aggiungiRelazioneUtenteGruppo(values);
        }
    }

    function onClickAggiungiGruppo() {
        if (formikRefGruppi.current) {
            formikRefGruppi.current.handleSubmit()
        }
    }

    function onClickVisualizzaPermessi(row) {
        setIdGruppoSel(row.id_gruppo_utente)
        setShowPermessi(true);
    }

    function onClickEliminaGruppo(row) {
        setGruppoSel(row);
        setShowConfirmGruppoDel(true);
    }

    return (
        <ModificaUtenteView
            optionsRuoli={optionsRuoli}
            formikRef={formikRef}
            show={show}
            setShow={setShow}
            gruppoSel={gruppoSel}
            statiUtenteAttivo={statiUtenteAttivo}
            translate={translate}
            modalMsg={modalMsg}
            SignupSchema={SignupSchema}
            formikRefGruppi={formikRefGruppi}
            gruppiUtente={gruppiUtente}
            idGruppoSel={idGruppoSel}
            idUsr={idUsr}
            isIdRuoloOperatore={isIdRuoloOperatore}
            isRuoloSuperAdmin={isRuoloSuperAdmin}
            optionsGruppi={optionsGruppi}
            utente={utente}
            setShowConfirmGruppoDel={setShowConfirmGruppoDel}
            setShowPermessi={setShowPermessi}
            showConfirmGruppoDel={showConfirmGruppoDel}
            showPermessi={showPermessi}
            handleOkConfirmElimina={handleOkConfirmElimina}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            initialValuesForm={initialValuesForm}
            initialValuesFormGrupi={initialValuesFormGrupi}
            onSubmitForm={onSubmitForm}
            onClickAggiungiGruppo={onClickAggiungiGruppo}
            onSubmitFormGruppi={onSubmitFormGruppi}
            onClickVisualizzaPermessi={onClickVisualizzaPermessi}
            onClickEliminaGruppo={onClickEliminaGruppo}
        />
    );
}